module.exports = __webpack_public_path__ + "static/media/7_r_Layer7_84.38_80.28.d301544e.png";